import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from '../alert';
import { InventoryService } from '../services/inventory.service';
import { AuthenticationService } from '../services/security/authentication.service';

@Component({
  selector: 'app-client-inventory',
  providers: [InventoryService],
  templateUrl: './client-inventory.component.html',
  styleUrls: ['./client-inventory.component.css']
})
export class ClientInventoryComponent implements OnInit {

    loading = false;
    shelves: any[] = [];
    articles: any[] = [];
    shelf: any;
    shelvesFiltered: any[] = [];
  
    constructor(
      private router: Router,
      private inventoryService: InventoryService,
      private alertService: AlertService,
      private authenticationService: AuthenticationService) { }
  
    ngOnInit() {
      this.getShelves();
    }
  
    doesMatch(element: any, filter) {
      return ((element != null && element.toLowerCase().indexOf(filter.toLowerCase())) >= 0);
    }
  
    doFilter(filterValue) {
      this.shelvesFiltered = [];
      this.shelves.forEach(shelf => {
        if (this.doesMatch(shelf.name, filterValue)) {
          if (!this.shelvesFiltered.find(item => item.name == shelf.name)) {
            this.shelvesFiltered.push(shelf);
          }
        }
      });
    }
  
    select(shelf) {
      this.shelf = shelf;
      this.getArticles();
    }
  
    unselect() {
      this.shelf = null;
      this.articles = [];
    }
  
    selectArticle(event) {
      this.router.navigate(['/article', '' + event.articleRef]);
    }
  
    getArticles() {
      this.loading = true;
      this.inventoryService.getArticlesOnShelf(this.shelf.name)
        .subscribe(
          data => {
            this.articles = data;
            this.loading = false;
          },
          error => {
            this.alertService.error(error);
            this.loading = false;
          });
    }
  
    getShelves() {
      this.loading = true;
      this.inventoryService.getAllShelves()
        .subscribe(
          data => {
            for (let item of data) {
              if (item.storage == this.authenticationService.getStorageName() ) {this.shelves.push(item);}
            }
            this.doFilter('');
            this.loading = false;
          },
          error => {
            this.alertService.error(error);
            this.loading = false;
          });
    }

  }
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/client-inventory/client-inventory.component.ts